import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core'
import { NavigationEnd, Router } from '@angular/router'

import { appConstants } from '../../app.constants'
import { Country } from '../../shared/interfaces/resources/country.interface'
import { Favorite } from '../../shared/interfaces/resources/favorite.interface'
import { CountryService } from '../../shared/services/country.service'
import { FavoriteService } from '../../shared/services/favorite.service'

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @ViewChild('countryMenu') countryMenuEl: ElementRef

  countries: Country[]
  favoriteIncentives: Favorite[]
  lastAddedIncentives: Favorite[]
  isUserAlreadyAddedIncentiveToCart = false

  activeItem: string
  activeCountry: string
  showMobileMenu = false
  isCountryDropdownExtended = false
  isLegalMenuExpanded = false
  isCartOpen = false

  constructor(
    private countryService: CountryService,
    private favoriteService: FavoriteService,
    private elem: ElementRef,
    private router: Router,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.countryService.list().then((countryRes: Country[]) => {
      this.countries = countryRes
    })

    this.favoriteIncentives = this.favoriteService.list()

    this.favoriteService.favoriteIncentives.subscribe({
      next: (newFavoriteIncentives) => {
        this.lastAddedIncentives = []
        this.isCartOpen = true

        // Compare new favorite incentives with old favorite incentives and add or remove incentives from the list accordingly.
        // This is necessary for the animation to work properly (changing the array instead of replacing it).
        newFavoriteIncentives.forEach((favoriteIncentive) => {
          if (
            !this.favoriteIncentives.find(
              (incentive) => incentive.id === favoriteIncentive.id
            )
          ) {
            this.favoriteIncentives.push(favoriteIncentive)

            if (!this.isUserAlreadyAddedIncentiveToCart) {
              this.lastAddedIncentives.push(favoriteIncentive)
            }
          }
        })

        this.favoriteIncentives = this.favoriteIncentives.filter((incentive) =>
          newFavoriteIncentives.find(
            (favoriteIncentive) => favoriteIncentive.id === incentive.id
          )
        )

        this.isUserAlreadyAddedIncentiveToCart = true
      }
    })

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url.substring(0, 11) === '/incentives') {
          this.activeItem = 'incentives'
          this.isUserAlreadyAddedIncentiveToCart = false
        } else if (event.url.substring(0, 10) === '/countries') {
          this.activeItem = 'countries'
        } else if (event.url.substring(0, 11) === '/comparator') {
          this.activeItem = 'comparator'
        } else if (event.url.substring(0, 6) === '/about') {
          this.activeItem = 'about'
        } else if (event.url.substring(0, 24) === '/indicators-and-analysis') {
          this.activeItem = 'indicators'
        } else {
          this.activeItem = ''
        }

        this.activeCountry = event.url.split('/')?.[2]
        this.isCountryDropdownExtended = false
        this.isCartOpen = false
      }
    })
  }

  toggleMobileMenu(closeOnly?: boolean): void {
    if (appConstants.windowBreakpoints.tablet > window.innerWidth) {
      if (this.showMobileMenu) {
        this.showMobileMenu = false
        this.renderer.removeClass(document.querySelector('html'), 'is-clipped')
      } else if (!closeOnly) {
        this.showMobileMenu = true
        this.renderer.addClass(document.querySelector('html'), 'is-clipped')
      }
    }
  }

  goToComparator(): void {
    this.router.navigate(['/comparator'])
  }

  @HostListener('document:click', ['$event'])
  clickOut(event: Event) {
    if (!this.elem.nativeElement.contains(event.target)) {
      this.isCountryDropdownExtended = false
    }
  }
}
